import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var ConnectLinks = /*#__PURE__*/function () {
  function ConnectLinks() {
    _classCallCheck(this, ConnectLinks);
    this.opacity = 0.5;
  }
  _createClass(ConnectLinks, [{
    key: "load",
    value: function load(data) {
      if (!(data !== undefined && data.opacity !== undefined)) {
        return;
      }
      this.opacity = data.opacity;
    }
  }]);
  return ConnectLinks;
}();